export default __webpack_public_path__ + "static/media/forward.4d23cacc.svg";